export default "__VITE_ASSET__DAICX_tv__"